import { FCPState } from '../enums/subscription-state.enum';

export class FCPActivationDetails {
    subscriptionState: FCPState;
    activationStartDate: Date;
    updatedBy: string;
    surveyData?: string;
}
